//angular
import { Component, Inject, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
//app
import { AppAnimations } from 'src/app/_shared/animations';
import { RestResponse, ShippingRatesModel } from 'src/app/_shared/models';
import { DataSharingService, LoaderService } from 'src/app/_core/services';
import { VisibleState, PaymentAccountType, GatewayType, collectionOfPaymentSourceOffline, PaymentSourceOffline, GatewayStatus } from 'src/app/app.data';
import { CustomerPaymentSource } from 'src/app/_shared/models/customer.model';
import { CompanyCurrency, CompanyGateway } from 'src/app/_shared/models/company.model';
import { PaymentFormComponent } from 'src/app/_shared/payment-form/payment-form.component';
import { POST_CustomerPaymentSourceInterface } from 'src/app/_shared/interfaces/customer.interface';
import { DropDown } from 'src/app/_shared/interfaces/dropdown.interface';
//services
import { SharedCustomerService } from 'src/app/_core/services/api/shared-customer.service';
import { MetaService } from 'src/app/_core/services/meta.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';

@Component({
  animations: [AppAnimations],
  selector: 'app-customer-payments',
  templateUrl: './customer-payments.component.html',
  styleUrls: ['customer-payments.component.scss']
})
export class DialogCustomerPaymentsComponent implements OnInit, OnDestroy {
  collectionOfCompanyGateway: Array<CompanyGateway> = [];
  collectionOfCustomerPaymentFiltered: Array<CustomerPaymentSource> = [];
  collectionOfCustomerPaymentSource: Array<CustomerPaymentSource> = [];
  collectionOfOfflinePaymentgateway: Array<CompanyGateway> = [];
  collectionOfShippingMethod: Array<ShippingRatesModel> = [];
  companyCurrencyBase: CompanyCurrency;
  companyCurrencyBaseGatewayDefault: CompanyGateway;
  customerId: any;
  form: FormGroup;
  formSubmitted: boolean = false;
  isFormReady: boolean = false;
  isCustomOptionSelected: boolean = false;
  isPaymentCardEnabled: boolean = false;
  isPaymentReady: boolean = false;
  isPaymentOfflineEnabled: boolean = false;
  newPaymentMethod: boolean = false;
  selectedCompanyCurrency: CompanyCurrency;
  selectedCompanyCurrencyId: number;
  selectedCompanyGateway: CompanyGateway;
  selectedCustomerPaymentMethod: any;
  selectedCustomerPaymentMethodOffLine: string = PaymentSourceOffline.other;
  selectedGatewayType: GatewayType;
  selectedShippingMethod: ShippingRatesModel;
  statusForOfflinePayments: VisibleState = VisibleState.isHidden;
  statusForRowInvoiceTotalOnCurrencyBase: VisibleState = VisibleState.isHidden;
  statusForThirdPartyPayments: VisibleState = VisibleState.isVisible;
  private subs = new Unsubscriber();

  @Input() _collectionOfPaymentSourceOffline: Array<DropDown> = collectionOfPaymentSourceOffline;
  @Input() _gatewayType = GatewayType;
  @Input() _paymentAccountType = PaymentAccountType;
  @ViewChild(PaymentFormComponent) _paymentFormComponent: PaymentFormComponent;

  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: any,
    private _dialogRef: MatDialogRef<DialogCustomerPaymentsComponent>,
    private _iconRegistry: MatIconRegistry,
    public _meta: MetaService,
    private _loader: LoaderService,
    private _sanitizer: DomSanitizer,
    private _shareData: DataSharingService,
    private sharedCustomerService: SharedCustomerService,
  ) {

    this._iconRegistry.addSvgIcon('ico-close', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-01.svg'));

    //Init Form
    this.form = new FormGroup({
      companyCurrencyId: new FormControl(),
      companyGatewayId: new FormControl(),
      customer: new FormControl(),
      customerId: new FormControl(),
      customerPaymentMethod: new FormControl(),
      offlinePaymentGateway: new FormControl(),
      offlinePaymentId: new FormControl(),
      paymentMethodId: new FormControl(),
      paymentType: new FormControl(),
    });

    // Subscribe to company currency base
    this.subs.addSub = this._shareData.currentCompanySettingsCurrencyBaseSource.subscribe(data => {
      this.companyCurrencyBase = data.currencyBase;
      if (this.companyCurrencyBase){
        this.selectedCompanyCurrency = this.companyCurrencyBase;
        this.form.get('companyCurrencyId').setValue(this.companyCurrencyBase.id);
        this.collectionOfCompanyGateway = this.companyCurrencyBase.companyGateway;
        this.collectionOfCompanyGateway.forEach((_companyGateway: CompanyGateway) => {
          if (_companyGateway.type == GatewayType.thirdPartyPaymentProvider){
            this.isPaymentCardEnabled = true;
          }
          if (_companyGateway.type == GatewayType.offlinePaymentProvider){
            this.collectionOfOfflinePaymentgateway.push(_companyGateway);
            this.isPaymentOfflineEnabled = true;
          }
          if (_companyGateway.isDefault) {
            this.selectedCompanyGateway = _companyGateway;
            this.companyCurrencyBaseGatewayDefault = _companyGateway;
            this.form.get('companyGatewayId').setValue(this.selectedCompanyGateway.id);
            this.form.get('paymentType').setValue(this.selectedCompanyGateway.type);
          }
        })
      }
    });
  }

  private addNewCardToInvoice(data: CustomerPaymentSource) {
    console.log('@@@@addNewCardToInvoice',data);
    let bodyParams = {
      companyGatewayId: null,
      customerPaymentMethodId: null,
      offlinePaymentMethodId: null,
      paymentType: null,
      paymentMethodId: null
    };

    bodyParams.companyGatewayId = data.companyGateway.id;
    bodyParams.customerPaymentMethodId = data.id;
    bodyParams.paymentType = this.selectedGatewayType;

    this._dialogRef.close({ bodyParams });
  }

  createPaymentSource(payment: any) {
    console.log('@@@@createPaymentSource',payment);

    let bodyParams: POST_CustomerPaymentSourceInterface = {
      accountKind: null,
      accountName: null,
      accountType: null,
      billingAddress: null,
      companyGatewayId: null,
      paymentMethod: null,
      type: null
    }

    let billingAddress = payment.billingAddress;

    bodyParams.accountKind = payment.accountKind
    bodyParams.accountName = payment.accountName,
    bodyParams.accountType = payment.accountType,
    bodyParams.billingAddress = {
      street1: billingAddress.street1,
      street2: billingAddress.street2 || '',
      city: billingAddress.city,
      state: billingAddress.state,
      zip: billingAddress.zip,
      countryId: billingAddress.country.id
    }
    bodyParams.companyGatewayId = payment.companyGatewayId,
    bodyParams.paymentMethod = {
      nonce: payment.paymentNonce
    }

    bodyParams.type = payment.type;

    if (billingAddress.id) {
      bodyParams.customerAddressBookId = billingAddress.id;
    }

    this.subs.addSub = this.sharedCustomerService.createPaymentMethodsByCustomerId(this._data.customer.id, bodyParams).subscribe(
      (res: RestResponse) => {
        this._meta.showNotification(res);
        const newCustomerCard = <CustomerPaymentSource>res.data;
        this.addNewCardToInvoice(newCustomerCard);
      },
      (err: RestResponse) => {
        this._meta.showNotification(err);
      }
    )
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {
    this.customerId = this._data.customer.id;
    this.onChangePaymentSource(this._data.paymentType);
    this.setCurrentValues();

    // Get Customers Payments
    this.subs.addSub = this.sharedCustomerService.getPaymentMethodsByCustomerId(this.customerId).subscribe(
      (res: RestResponse) => {
        this.collectionOfCustomerPaymentSource = <Array<CustomerPaymentSource>>res.data;

        if (this.collectionOfCustomerPaymentSource.length == 0) {
          this.selectedCustomerPaymentMethod = '0';
        } else {
          this.selectedCustomerPaymentMethod = null; //TODO: ver esto
          this.collectionOfCustomerPaymentFiltered = [];
          this.collectionOfCustomerPaymentSource = <Array<CustomerPaymentSource>>res.data;
          this.collectionOfCustomerPaymentSource.forEach((_paymentMethod: CustomerPaymentSource) => {
            this.collectionOfCompanyGateway.forEach((_companyGateway:CompanyGateway)=> {
            if(_companyGateway.status === GatewayStatus.active) {
              if (_paymentMethod.companyGateway.id === _companyGateway.id) {
              this.collectionOfCustomerPaymentFiltered.push(_paymentMethod);
                if (!this.selectedCustomerPaymentMethod) {
                  if(this._data.customerPaymentMethod &&
                    _paymentMethod.id === this._data.customerPaymentMethod.id ) {
                    this.selectedCustomerPaymentMethod = _paymentMethod;
                    this.form.get('companyGatewayId').setValue(this.selectedCustomerPaymentMethod.companyGateway.id);
                    this.form.get('customerPaymentMethod').setValue(this.selectedCustomerPaymentMethod);
                  }
                }
              }
            }
            });
          });
        }

        this.isPaymentReady = true;
      },
      (err: RestResponse) => {
        console.log('@@@getCustomerPaymentMethods.',err);
        this.isPaymentReady = true;
      }
    );
  }

  onChangeCustomerPaymentMethod(_selectedValue: CustomerPaymentSource) {
    //select dentro de las tarjetas de credito
    this.selectedCustomerPaymentMethod = _selectedValue;
    if (this.selectedCustomerPaymentMethod !== '0' && this.selectedCustomerPaymentMethod !== null) {
      this.selectedCompanyGateway = _selectedValue.companyGateway;
      this.form.get('customerPaymentMethod').setValue(_selectedValue);
      this.form.get('companyGatewayId').setValue(_selectedValue.companyGateway.id);
      this.newPaymentMethod = false;
    } else {
      //selecciona nueva
      this.selectedCompanyGateway = this.companyCurrencyBaseGatewayDefault;
      this.form.get('customerPaymentMethod').setValue('');
      this.form.get('companyGatewayId').setValue(this.selectedCompanyGateway.id);
      this.newPaymentMethod = true;
    }
  }

  onChangeOfflinePaymentMethod(_selectedValue: PaymentSourceOffline) {
    console.log('@@',_selectedValue);
  }

  onChangePaymentSource(_value:GatewayType) {
    this.statusForOfflinePayments = VisibleState.isHidden;
    this.statusForThirdPartyPayments = VisibleState.isHidden;
    switch (_value) {
      case GatewayType.thirdPartyPaymentProvider:
        this.statusForThirdPartyPayments = VisibleState.isVisible;
        this.selectedGatewayType = GatewayType.thirdPartyPaymentProvider;
        this.form.get('offlinePaymentId').setValue(null);
        this.form.get('paymentType').setValue(GatewayType.thirdPartyPaymentProvider);
        break;
      case GatewayType.offlinePaymentProvider:
        this.statusForOfflinePayments = VisibleState.isVisible;
        this.selectedGatewayType = GatewayType.offlinePaymentProvider;
        this.form.get('companyGatewayId').setValue(null);
        this.form.get('customerPaymentMethod').setValue(null);
        this.form.get('offlinePaymentGateway').setValue(null);
        this.form.get('offlinePaymentId').setValue(null);
        this.form.get('paymentType').setValue(GatewayType.offlinePaymentProvider);
        this.newPaymentMethod = false;
        break;
    }
  }

  onClose() {
    this._dialogRef.close();
  }

  onGetData(_data: any) {
    this.createPaymentSource(_data);
  }

  onSubmit() {
    this.formSubmitted = !this.formSubmitted;

    if (this.form.invalid) {
      this.formSubmitted = !this.formSubmitted;
      this.form.markAllAsTouched();
      this.form.markAsDirty();
      return;
    }

    let bodyParams = {
      companyGatewayId: null,
      customerPaymentMethodId: null,
      offlinePaymentMethodId: null,
      paymentType: null,
      paymentMethodId: null
    };

    bodyParams.paymentType = this.selectedGatewayType;
    if (this.selectedGatewayType == GatewayType.offlinePaymentProvider){
      bodyParams.companyGatewayId = this.form.get('offlinePaymentGateway').value
      let offlinePaymentMethod = this.form.get('offlinePaymentId').value
      bodyParams.offlinePaymentMethodId = offlinePaymentMethod?.value;
    }
    else
    {
      bodyParams.companyGatewayId = this.form.get('companyGatewayId').value,
      bodyParams.customerPaymentMethodId= this.selectedCustomerPaymentMethod?.id
    }

    console.log('@@@@onSubmit', bodyParams);

    if ((this.selectedCustomerPaymentMethod === '0' || this.selectedCustomerPaymentMethod === null) && this.selectedGatewayType !== GatewayType.offlinePaymentProvider) {
      this._paymentFormComponent.processCardPaymentForm();
    } else {
      this._loader.startPageLoader();
      this._dialogRef.close({ bodyParams });
    }
  }

  setCurrentValues() {
    const selectedMethod= this._data.paymentType;
    switch (selectedMethod) {
      case GatewayType.thirdPartyPaymentProvider:
        this.selectedCustomerPaymentMethod = this._data.customerPaymentMethod;
        this.onChangeCustomerPaymentMethod(this.selectedCustomerPaymentMethod);
        break;
      case GatewayType.offlinePaymentProvider:
        this.form.get('offlinePaymentGateway').setValue(this._data.companyGateway.id);

        let selectedOfflinePaymentId = this._collectionOfPaymentSourceOffline.find(x=>x.value==this._data.offlinePaymentId);
        this.form.get('offlinePaymentId').setValue(selectedOfflinePaymentId);

        this.selectedCustomerPaymentMethod = null;
        this.form.get('customerPaymentMethod').setValue(null);
        break;
    }
  }

  onSelectPriorityButtonEvent(e) {
    e.stopPropagation();
    e.preventDefault();
    return false;
  }

  // setCustomerPaymentMethod(customerPaymentMethod,status) {
  //   const previousSelection = this.collectionOfCustomerPaymentFiltered.find(customerPaymentMethod =>customerPaymentMethod.priority === status)

  //   if(customerPaymentMethod.priority && customerPaymentMethod.priority == 'primary' && status === 'secondary') {
  //     return;
  //   }

  //   if(previousSelection) {

  //     previousSelection.priority = null;
  //   }
  //   customerPaymentMethod.priority = status;
  // }
}
